import React, { useState, useEffect } from 'react';
import { staffAPI } from '../../services/api';
import { formatCurrency, formatDate } from '../../utils/helpers';
import './staff.scss';

const staffList = [
  { id: 1, name: "Sridar", department: "Admin", designation: "Administrator", email: "sridar@gmail.com", bank: "111122223333", pf: "PF10001", salary: 30000, takeHome: 27000, deduction: 3000, earnings: [{ component: "Basic", percentage: 80, amount: 24000 }, { component: "HRA", percentage: 10, amount: 3000 }, { component: "OA", percentage: 6, amount: 2000 }, { component: "Conveyance", percentage: 4, amount: 1000 }], deductions: [{ component: "PF Employee", amount: 1000 }, { component: "ESI Employee", amount: 500 }, { component: "Loan", amount: 1000 }, { component: "Professional Tax", amount: 500 }] },
  { id: 2, name: "Rahul", department: "Principal", designation: "Principal", email: "rahul@gmail.com", bank: "222233334444", pf: "PF10002", salary: 50000, takeHome: 45000, deduction: 5000, earnings: [{ component: "Basic", percentage: 80, amount: 40000 }, { component: "HRA", percentage: 10, amount: 5000 }, { component: "OA", percentage: 6, amount: 3000 }, { component: "Conveyance", percentage: 4, amount: 2000 }], deductions: [{ component: "PF Employee", amount: 2000 }, { component: "ESI Employee", amount: 1000 }, { component: "Loan", amount: 1000 }, { component: "Professional Tax", amount: 1000 }] },
  { id: 3, name: "Ramesh", department: "Teacher", designation: "Teacher", email: "ramesh@gmail.com", bank: "333344445555", pf: "PF10003", salary: 25000, takeHome: 22000, deduction: 3000, earnings: [{ component: "Basic", percentage: 80, amount: 20000 }, { component: "HRA", percentage: 10, amount: 2500 }, { component: "OA", percentage: 6, amount: 1500 }, { component: "Conveyance", percentage: 4, amount: 1000 }], deductions: [{ component: "PF Employee", amount: 1000 }, { component: "ESI Employee", amount: 500 }, { component: "Loan", amount: 1000 }, { component: "Professional Tax", amount: 500 }] },
  { id: 4, name: "Rakesh", department: "Librarian", designation: "Librarian", email: "rakesh@gmail.com", bank: "444455556666", pf: "PF10004", salary: 20000, takeHome: 18000, deduction: 2000, earnings: [{ component: "Basic", percentage: 80, amount: 16000 }, { component: "HRA", percentage: 10, amount: 2000 }, { component: "OA", percentage: 6, amount: 1000 }, { component: "Conveyance", percentage: 4, amount: 1000 }], deductions: [{ component: "PF Employee", amount: 1000 }, { component: "ESI Employee", amount: 500 }, { component: "Loan", amount: 300 }, { component: "Professional Tax", amount: 200 }] }
];

const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const years = [2024, 2025, 2026];

const emptyForm = {
  empName: "", designation: "", department: "", year: "2025", month: "January",
  e_basic: "", e_hra: "", e_conv: "", e_trans: "", e_cea: "", e_others: "", e_medical: "",
  e_gross_pm: "", e_pf_employer: "", e_esi_employer: "", e_medical2: "", e_telephone: "", e_others2: "",
  d_pf: "", d_esi: "", d_loan: "", d_tax: ""
};

const earningKeys = ["e_basic", "e_hra", "e_conv", "e_trans", "e_cea", "e_others", "e_medical", "e_gross_pm", "e_pf_employer", "e_esi_employer", "e_medical2", "e_telephone", "e_others2"];
const deductKeys = ["d_pf", "d_esi", "d_loan", "d_tax"];

const earningLabels = {
  e_basic: "Basic", e_hra: "H R A", e_conv: "Conv. All", e_trans: "Trans. All",
  e_cea: "CEA", e_others: "Others", e_medical: "Medical Allowance",
  e_gross_pm: "SALARY (GROSS) / PM", e_pf_employer: "PF Employer",
  e_esi_employer: "ESI Employer", e_medical2: "Medical", e_telephone: "Telephone", e_others2: "Others (2)"
};
const deductLabels = { d_pf: "PF Employee", d_esi: "ESI Employee", d_loan: "Loan", d_tax: "Tax" };

function calcTotals(form) {
  const totalE = earningKeys.reduce((s, k) => s + (parseFloat(form[k]) || 0), 0);
  const totalD = deductKeys.reduce((s, k) => s + (parseFloat(form[k]) || 0), 0);
  return { totalE, totalD, net: Math.max(0, totalE - totalD) };
}

// Convert a staffList item OR a saved slip into flat form shape
function toForm(item) {
  if (!item) return emptyForm;
  return {
    empName: item.empName || item.name || "",
    designation: item.designation || "",
    department: item.department || "",
    year: String(item.year || "2025"),
    month: item.month || "January",
    e_basic: item.e_basic ?? (item.earnings?.[0]?.amount ?? ""),
    e_hra: item.e_hra ?? (item.earnings?.[1]?.amount ?? ""),
    e_conv: item.e_conv ?? (item.earnings?.[2]?.amount ?? ""),
    e_trans: item.e_trans ?? (item.earnings?.[3]?.amount ?? ""),
    e_cea: item.e_cea ?? "",
    e_others: item.e_others ?? "",
    e_medical: item.e_medical ?? "",
    e_gross_pm: item.e_gross_pm ?? "",
    e_pf_employer: item.e_pf_employer ?? "",
    e_esi_employer: item.e_esi_employer ?? "",
    e_medical2: item.e_medical2 ?? "",
    e_telephone: item.e_telephone ?? "",
    e_others2: item.e_others2 ?? "",
    d_pf: item.d_pf ?? (item.deductions?.[0]?.amount ?? ""),
    d_esi: item.d_esi ?? (item.deductions?.[1]?.amount ?? ""),
    d_loan: item.d_loan ?? (item.deductions?.[2]?.amount ?? ""),
    d_tax: item.d_tax ?? (item.deductions?.[3]?.amount ?? ""),
  };
}

// ─── Salary Modal (Create + Edit) ────────────────────────────────────────────
const SalaryModal = ({ show, onClose, onSave, editData }) => {
  const isEdit = !!editData;
  const [form, setForm] = useState(emptyForm);
  const { totalE, totalD, net } = calcTotals(form);

  // Populate form when modal opens
  useEffect(() => {
    if (show) setForm(isEdit ? toForm(editData) : emptyForm);
  }, [show, editData]);

  const change = e => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const handleSave = () => {
    if (!form.empName) { alert("Please select an employee name."); return; }
    onSave({ ...form, totalE, totalD, net, id: editData?.id || Date.now() });
    onClose();
  };

  if (!show) return null;
  const rowCount = Math.max(earningKeys.length, deductKeys.length);

  return (
    <div className="modal d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)", zIndex: 1055 }}>
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content p-3 custom-modal">

          <div className="modal-header py-2 px-0">
            <h5 className="modal-title fw-bold mb-2 text-primary">
              {isEdit ? "Edit Salary Slip" : "Process Salary"}
            </h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body p-0">
            <table className="table table-bordered m-0" style={{ fontSize: 13 }}>
              <tbody>
                {/* Department */}
                <tr>
                  <td><b>Department :</b></td>
                  <td colSpan={3}>
                    <select className="form-select form-select-sm border-0" name="department" value={form.department} onChange={change}>
                      <option value="">-- Select --</option>
                      {[...new Set(staffList.map(s => s.department))].map(d => <option key={d}>{d}</option>)}
                    </select>
                  </td>
                </tr>

                {/* Designation */}
                <tr>
                  <td><b>Designation :</b></td>
                  <td colSpan={3}>
                    <select className="form-select form-select-sm border-0" name="designation" value={form.designation} onChange={change}>
                      <option value="">-- Select --</option>
                      {[...new Set(staffList.map(s => s.designation))].map(d => <option key={d}>{d}</option>)}
                    </select>
                  </td>
                </tr>

                {/* Employee Name */}
                <tr>
                  <td style={{ width: 160 }}><b>Employee Name :</b></td>
                  <td colSpan={3}>
                    <select className="form-select form-select-sm border-0" name="empName" value={form.empName} onChange={change}>
                      <option value="">-- Select --</option>
                      {staffList.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
                    </select>
                  </td>
                </tr>
                {/* Year / Month */}
                <tr>
                  <td><b>Year :</b></td>
                  <td>
                    <select className="form-select form-select-sm border-0" name="year" value={form.year} onChange={change}>
                      {years.map(y => <option key={y}>{y}</option>)}
                    </select>
                  </td>
                  <td style={{ width: 80 }}><b>Month :</b></td>
                  <td>
                    <select className="form-select form-select-sm border-0" name="month" value={form.month} onChange={change}>
                      {months.map(m => <option key={m}>{m}</option>)}
                    </select>
                  </td>
                </tr>

                {/* Section headers */}
                <tr>
                  <th colSpan={2} className="text-center bg-light">Earnings</th>
                  <th colSpan={2} className="text-center bg-light">Deductions</th>
                </tr>
                <tr>
                  <th className="bg-light">Salary Head</th>
                  <th className="bg-light">Amount</th>
                  <th className="bg-light" style={{ width: 150 }}>Salary Head</th>
                  <th className="bg-light">Amount</th>
                </tr>

                {/* Earning + Deduction rows */}
                {Array.from({ length: rowCount }).map((_, i) => {
                  const ek = earningKeys[i];
                  const dk = deductKeys[i];
                  return (
                    <tr key={i}>
                      <td style={{ fontWeight: ek === "e_gross_pm" ? 600 : "normal" }}>
                        {ek ? earningLabels[ek] : ""}
                      </td>
                      <td>
                        {ek && (
                          <input
                            type="number"
                            className="form-control form-control-sm border-0 p-0"
                            name={ek}
                            value={form[ek]}
                            onChange={change}
                            placeholder="0"
                          />
                        )}
                      </td>
                      <td>{dk ? deductLabels[dk] : ""}</td>
                      <td>
                        {dk && (
                          <input
                            type="number"
                            className="form-control form-control-sm border-0 p-0"
                            name={dk}
                            value={form[dk]}
                            onChange={change}
                            placeholder="0"
                          />
                        )}
                      </td>
                    </tr>
                  );
                })}

                {/* Totals */}
                <tr className="fw-bold">
                  <td className="py-2 bg-light">Salary (Total)</td>
                  <td className="py-2 bg-light">₹ {totalE.toLocaleString("en-IN")}</td>
                  <td className="py-2 bg-light">Total Deduction</td>
                  <td className="py-2 bg-light">₹ {totalD.toLocaleString("en-IN")}</td>
                </tr>

                {/* Net Salary */}
                <tr>
                  <td colSpan={4} className="text-center fw-bold text-success py-2" style={{ fontSize: 15, background: "#e8f5e9" }}>
                    Net Salary : ₹ {net.toLocaleString("en-IN")}
                  </td>
                </tr>

              </tbody>
            </table>
          </div>

          <div className="modal-footer py-2">
            <button className="btn btn-outline-secondary" onClick={() => setForm(emptyForm)}>Clear</button>
            <button className="btn btn-primary" onClick={handleSave}>
              {isEdit ? "Update" : "Save"}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

// ─── Main Component ───────────────────────────────────────────────────────────
const StaffPayroll = () => {
  const [payrolls, setPayrolls] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({ month: new Date().getMonth() + 1, year: new Date().getFullYear() });
  const [department, setDepartment] = useState("");
  const [designation, setDesignation] = useState("");
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(() => {
    const t = new Date();
    return t.getMonth() === 0 ? "December" : months[t.getMonth() - 1];
  });
  const [selectedStaff, setSelectedStaff] = useState(staffList[0]);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);   // null = create mode
  const [savedSlips, setSavedSlips] = useState([]);

  useEffect(() => {
    setLoading(true);
    Promise.allSettled([
      staffAPI.payroll(filter),
      staffAPI.list({ page_size: 100, status: 'active' }),
    ]).then(([pRes]) => {
      if (pRes.status === 'fulfilled') setPayrolls(pRes.value.data.results || pRes.value.data);
    }).finally(() => setLoading(false));
  }, [filter]);

  const filteredStaff = staffList.filter(item =>
    (department === "" || item.department === department) &&
    (designation === "" || item.designation === designation)
  );

  // Open modal in CREATE mode
  const openCreate = () => { setEditData(null); setShowModal(true); };

  // Open modal in EDIT mode — works for both staffList items and savedSlips
  const openEdit = (item, e) => {
    e.stopPropagation();
    setEditData(item);
    setShowModal(true);
  };

  const handleSave = slip => {
    setSavedSlips(prev => {
      const exists = prev.find(s => s.id === slip.id);
      return exists
        ? prev.map(s => s.id === slip.id ? slip : s)  // update
        : [slip, ...prev];                             // add new
    });
    const matched = staffList.find(s => s.name === slip.empName);
    if (matched) setSelectedStaff(matched);
  };

  return (
    <div>
      <div className="page-header">
        <div><h2>Payroll Management</h2></div>
        <button className="btn btn-primary" onClick={openCreate}>➕ Create Salary</button>
      </div>

      {/* Modal */}
      <SalaryModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onSave={handleSave}
        editData={editData}
      />

      <div className="card">
        <div className="card-header"><span>💰 Payroll Records ({payrolls.length})</span></div>
        <div className="card-body">
          <div className="container-fluid mt-3">

            {/* Filters */}
            <div className="row mb-3">
              <div className="col-md-2">
                <select className="form-select" value={department} onChange={e => setDepartment(e.target.value)}>
                  <option value="">All Department</option>
                  {[...new Set(staffList.map(x => x.department))].map(dep => <option key={dep} value={dep}>{dep}</option>)}
                </select>
              </div>
              <div className="col-md-2">
                <select className="form-select" value={designation} onChange={e => setDesignation(e.target.value)}>
                  <option value="">All Designation</option>
                  {[...new Set(staffList.map(x => x.designation))].map(des => <option key={des} value={des}>{des}</option>)}
                </select>
              </div>
              <div className="col-md-2">
                <select className="form-select" value={year} onChange={e => setYear(e.target.value)}>
                  {years.map(y => <option key={y} value={y}>{y}</option>)}
                </select>
              </div>
              <div className="col-md-2">
                <select className="form-select" value={month} onChange={e => setMonth(e.target.value)}>
                  {months.map(m => <option key={m} value={m}>{m}</option>)}
                </select>
              </div>
              <div className="col-md-4 text-end">
                Paid Days:<b className="me-3"> 30</b>
                LOP:<b className="me-3"> 0</b>
                <button className="btn btn-outline-success btn-sm">Download Payslip</button>
              </div>
            </div>

            <div className="row">
              {/* LEFT: Staff table */}
              <div className="col-md-4">
                <table className="table table-bordered" style={{ fontSize: 13 }}>
                  <thead>
                    <tr><th>S.No.</th><th>Employee Name</th><th>Department</th><th>Action</th></tr>
                  </thead>
                  <tbody>

                    {/* Static staffList rows */}
                    {filteredStaff.map((item, index) => (
                      <tr key={item.id}
                        onClick={() => setSelectedStaff(item)}
                        className={selectedStaff?.id === item.id ? "active-row" : ""}
                        style={{ cursor: "pointer", background: selectedStaff?.id === item.id ? "" : "#f0fff4" }}
                      >
                        <td>{index + 1}</td>
                        <td>{item.name}</td>
                        <td>{item.department}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-outline-primary py-0 px-2"
                            style={{ fontSize: 12 }}
                            onClick={e => openEdit(item, e)}
                          >
                            ✏️ Edit
                          </button>
                        </td>
                      </tr>
                    ))}

                    {/* Saved slip rows */}
                    {savedSlips.map((slip, index) => (
                      <tr key={slip.id} style={{ cursor: "pointer", background: "#f0fff4" }}>
                        <td>{filteredStaff.length + index + 1}</td>
                        <td>
                          <span className="badge bg-success me-1" style={{ fontSize: 10 }}>New</span>
                          {slip.empName}
                        </td>
                        <td>{slip.department}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-outline-warning py-0 px-2"
                            style={{ fontSize: 12 }}
                            onClick={e => openEdit(slip, e)}
                          >
                            ✏️ Edit
                          </button>
                        </td>
                      </tr>
                    ))}

                  </tbody>
                </table>

                {/* Saved slip summary cards */}
                {savedSlips.length > 0 && (
                  <div className="mt-2">
                    <div className="fw-bold mb-2" style={{ fontSize: 13 }}>Recently Saved Slips</div>
                    {savedSlips.map(slip => (
                      <div key={slip.id} className="card mb-2 border-success" style={{ fontSize: 12 }}>
                        <div className="card-body py-2 px-3">
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="fw-bold">{slip.empName} — {slip.month} {slip.year}</div>
                            <button
                              className="btn btn-sm btn-outline-warning py-0 px-2"
                              style={{ fontSize: 11 }}
                              onClick={e => openEdit(slip, e)}
                            >
                              ✏️ Edit
                            </button>
                          </div>
                          <div className="text-muted">{slip.designation} | {slip.department}</div>
                          <div className="d-flex justify-content-between mt-1">
                            <span className="text-success">Take Home: ₹{slip.net.toLocaleString("en-IN")}</span>
                            <span className="text-danger">Deduction: ₹{slip.totalD.toLocaleString("en-IN")}</span>
                          </div>
                          <div className="text-secondary">Gross: ₹{slip.totalE.toLocaleString("en-IN")}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* RIGHT: Payroll detail */}
              <div className="col-md-8">
                <div className="card payroll-card">
                  <div className="card-body">
                    <div className="row align-items-center">
                      <div className="col-md-3">
                        <div className="month-circle">
                          <h3>{month.substring(0, 3).toUpperCase()}</h3>
                          <h5>{year}</h5>
                        </div>
                      </div>
                      <div className="col-md-3"><h5 className="text-success">Take Home</h5><h3>{selectedStaff.takeHome}</h3></div>
                      <div className="col-md-3"><h5 className="text-warning">Deduction</h5><h3>{selectedStaff.deduction}</h3></div>
                      <div className="col-md-3"><h5 className="text-info">Gross Salary</h5><h3>{selectedStaff.salary}</h3></div>
                    </div>

                    <div className="employee-details-box mt-3">
                      <div className="employee-title">Employee Details</div>
                      <div className="row employee-info">
                        <div className="col-md-6">
                          <p>Employee Name: <span>{selectedStaff.name}</span></p>
                          <p>Employee ID: <span>EMP-{selectedStaff.id}abc</span></p>
                          <p>Employee Email: <span>{selectedStaff.email}</span></p>
                          <p>Contact No: <span>9989953568</span></p>
                        </div>
                        <div className="col-md-6">
                          <p>Department: <span>{selectedStaff.department}</span></p>
                          <p>Designation: <span>{selectedStaff.designation}</span></p>
                          <p>Bank Account: <span>{selectedStaff.bank}</span></p>
                          <p>PF No: <span>{selectedStaff.pf}</span></p>
                        </div>
                      </div>
                    </div>

                    <div className="container-fluid">
                      <div className="row payroll-tables mt-0">
                        <div className="col-md-7 p-0">
                          <h5 className="earning-title">Standard Earnings</h5>
                          <table className="table table-bordered m-0">
                            <thead><tr><th>Pay Component</th><th>Percentage(%)</th><th>Amount</th></tr></thead>
                            <tbody>
                              {(selectedStaff.earnings || []).map((e, i) => (
                                <tr key={i}><td>{e.component}</td><td>{e.percentage}</td><td>{e.amount}</td></tr>
                              ))}
                              <tr className="fw-bold"><td colSpan="2">Grand Total</td><td>{selectedStaff.salary}</td></tr>
                            </tbody>
                          </table>
                        </div>
                        <div className="col-md-5 p-0">
                          <h5 className="deduction-title">Standard Deductions</h5>
                          <table className="table table-bordered m-0">
                            <thead><tr><th>Pay Component</th><th>Amount</th></tr></thead>
                            <tbody>
                              {(selectedStaff.deductions || []).map((d, i) => (
                                <tr key={i}><td>{d.component}</td><td>{d.amount}</td></tr>
                              ))}
                              <tr className="fw-bold bg-light"><td>Grand Total</td><td>{selectedStaff.deduction}</td></tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="net-salary-box">
                      <div>Net Salary</div>
                      <div className="text-success">{selectedStaff.takeHome}.00</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffPayroll;
